import React from "react";
import { m as motion } from "../../shared/components/Motion";
import "./works-skeleton.css";

const skeletonVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.3,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0.5 },
  visible: { opacity: 1 },
};

const WorksSkeleton = ({ data = null }) => {
  // Helper: Convert Firestore object representation to array
  const toArray = (data) => {
    if (Array.isArray(data)) return data;
    if (typeof data === "object" && data !== null) {
      return Object.values(data).filter((item) => typeof item === "object");
    }
    return [];
  };

  // Dynamic skeleton cards based on actual data, fallback to 6 if no data
  const projectsData = data?.items ? toArray(data.items) : [];
  const cardCount = projectsData.length > 0 ? projectsData.length : 6;
  const skeletonCards = Array.from({ length: cardCount }, (_, i) => i);

  return (
    <motion.div initial="hidden" animate="visible" variants={skeletonVariants}>
      {/* Filter Buttons Skeleton */}
      <motion.div className="work__filters" variants={itemVariants}>
        <div className="work__item skeleton-filter-item"></div>
        <div className="work__item skeleton-filter-item"></div>
        <div className="work__item skeleton-filter-item"></div>
      </motion.div>

      {/* Cards Grid Skeleton */}
      <motion.div className="work__container grid" variants={skeletonVariants}>
        {skeletonCards.map((_, index) => (
          <motion.div
            key={index}
            className="work__card skeleton-card-border"
            variants={itemVariants}
            style={{ position: "relative" }}
          >
            {/* Image Skeleton */}
            <div
              className="work__img-container skeleton-img-container"
              style={{
                width: "295px",
                height: "175px",
              }}
            >
              <div
                className="skeleton-img"
                style={{
                  width: "100%",
                  height: "100%",
                }}
              ></div>
            </div>

            {/* Title Skeleton */}
            <div
              className="skeleton-text skeleton-title"
              style={{ marginTop: "10px" }}
            ></div>

            {/* Button Skeleton */}
            <div
              className="skeleton-text skeleton-button-text"
              style={{ marginTop: "12px", width: "120px" }}
            ></div>
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default WorksSkeleton;
